import * as IsActive from '../../components/is_active'

export const FETCH_NEWSBRIEF_COUNTS = 'FETCH_NEWSBRIEF_COUNTS'
export const RESUBMIT_ISSUE = 'RESUBMIT_ISSUE'
export const CANCEL_ISSUE = 'CANCEL_ISSUE'

export const SERVER_RESOURCE = '/newsbriefs'
export const GENERATE_NEWSBRIEF_RESOURCE = '/newsbrief'

export const DATE_SELECT_TODAY_MODE = 'today'
export const DATE_SELECT_YESTERDAY_MODE = 'yesterday'
export const DATE_SELECT_LASTWEEK_MODE = 'lastweek'
export const DATE_SELECT_CUSTOM_MODE = 'custom'

export const NEWSLETTER_COUNTS_UPDATE_SELECTED_DATE = `NEWSLETTER_COUNTS_${IsActive.UPDATE_SELECTED_DATE}`

export const CHANGE_DATE_SELECT = 'CHANGE_DATE_SELECT'

export const DATE_SELECT_TODAY: IsActive.Filter = {
    description: 'Today',
    key: 'mode',
    value: DATE_SELECT_TODAY_MODE,
  }

export const DATE_SELECT_YESTERDAY: IsActive.Filter = {
  description: 'Yesterday',
  key: 'mode',
  value: DATE_SELECT_YESTERDAY_MODE,
}

export const DATE_SELECT_LASTWEEK: IsActive.Filter = {
  description: 'Last Week',
  key: 'mode',
  value: DATE_SELECT_LASTWEEK_MODE,
}

export const DATE_SELECT_CUSTOM: IsActive.Filter = {
  description: 'Pick a date',
  key: 'mode',
  value: DATE_SELECT_CUSTOM_MODE,
}

export const dateSelectFilters = [DATE_SELECT_TODAY, DATE_SELECT_YESTERDAY, DATE_SELECT_LASTWEEK, DATE_SELECT_CUSTOM]



// WEBPACK FOOTER //
// ./src/pages/newsbrief-counts/constants.ts